import {AfterViewInit, Component, Injector, Input} from '@angular/core';
import { BaseControlValueAccessor } from '../../../../shared/core/base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SectionState } from '../../../../shared/components/section/section.model';
import { RequeteCategory } from '../../../../entities/requete';
import { RadioFieldsetItem } from '../../../radio-fieldset/radio-fieldset-item.interface';

@Component({
  selector: 'jhi-requerant-type-section',
  templateUrl: './requerant-type-section.component.html',
  styleUrls: ['./requerant-type-section.component.scss'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: RequerantTypeSectionComponent,
        multi: true
    }
]
})
export class RequerantTypeSectionComponent extends BaseControlValueAccessor implements AfterViewInit {

    RequeteCategoryEnum = RequeteCategory;

    selectedRequerantTypeCode: string

    requerantTypes: RadioFieldsetItem[] = [
        {
            value: this.RequeteCategoryEnum.REQUERANT_SEUL,
            title: 'En tant que seul requérant',
            description: 'Le terme requérant désigne la personne qui s’adresse au juge pour lui soumettre un litige.'
        },
        {
            value: this.RequeteCategoryEnum.COLLECTIVE,
            title: 'Avec d\'autres requérants',
            description: 'Plusieurs personnes physiques ou morales peuvent déposer la même requête. L’un d’entre eux doit être' +
            ' désigné comme représentant unique des requérants. Lorsque cette requête est déposée par Télérecours citoyens,' +
            ' la personne qui l’a introduite est désignée représentant unique. Pour plus d\'informations, lisez '
        },
        {
            value: this.RequeteCategoryEnum.AVEC_MANDATAIRE,
            title: 'En tant que mandataire',
            description: 'Le requérant vous a donné un mandat par lequel il vous autorise à agir en justice en son nom.' +
                ' Vous devrez joindre ce mandat, ou pouvoir spécial, à l\'appui de la requête.'
        }
    ]

    @Input()
    state: SectionState;

    constructor(injector: Injector) {
        super(injector);
    }

    protected modelValueChanged(value: any): void {
        this.selectedRequerantTypeCode = value;
    }

    onSetRequeteType(requeteCategory: RequeteCategory) {
        this.onChange(requeteCategory);
    }

    ngAfterViewInit() {
      document.getElementById('logo-link').focus();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requerants/requerant-type-section/requerant-type-section.component.ts